import { Reducer } from 'redux'
import { Action, ActionTypes } from 'mobile/Actions/actionConstants'
import {IOrder} from "shared/Types/appTypes";

export interface IMeetingOptionsModal {
    open: boolean
    order: IOrder | null
}

const initialState: IMeetingOptionsModal = {
    open: false,
    order: null,
};

const meetingOptionsModalReducer: Reducer<IMeetingOptionsModal, Action> = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.OPEN_MEETING_OPTIONS_MODAL:
            return {
                ...state,
                open: true,
                order: action.order,
            };
        case ActionTypes.CLOSE_MEETING_OPTIONS_MODAL:
            return {
                ...state,
                open: false,
            };
        default:
            return state
    }
};

export default meetingOptionsModalReducer
